import { Text, makeStyles } from '@fluentui/react-components';
import { Checkmark16Filled } from '@fluentui/react-icons';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    transitionProperty: 'opacity, transform',
    transitionDuration: '0.2s, 0.1s',
    transitionTimingFunction: 'ease-in-out',
    ':hover': {
      opacity: 0.9,
    },
    ':active': {
      transform: 'scale(0.98)',
    },
  },
  hiddenInput: {
    position: 'absolute',
    opacity: 0,
    width: '1px',
    height: '1px',
  },
  box: {
    width: '24px',
    height: '24px',
    borderRadius: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  checkIcon: {
    color: '#50BCBD',
    flexShrink: 0,
    fontSize: '20px',
    filter: 'drop-shadow(0 0 8px #50BCBD) drop-shadow(0 0 12px #50BCBD)',
  },
  text: {
    color: '#ffffff',
    flex: 1,
    pointerEvents: 'none',
  },
});

type CheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
};

export const Checkbox = ({ checked, onChange, label, className }: CheckboxProps) => {
  const styles = useStyles();

  return (
    <label className={`${styles.wrapper}${className ? ` ${className}` : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={styles.hiddenInput}
        aria-checked={checked}
      />
      <span className={styles.box} aria-hidden="true">
        {checked && <Checkmark16Filled className={styles.checkIcon} aria-hidden="true" />}
      </span>
      <Text size={200} weight="regular" className={styles.text}>
        {label}
      </Text>
    </label>
  );
};
